var $7097f64386f1761c$exports = {};
$7097f64386f1761c$exports = {
    "alpha": `Alfa`,
    "blue": `Bl\xe5`,
    "brightness": `Lysstyrke`,
    "green": `Gr\xf8n`,
    "hue": `Tone`,
    "lightness": `Lyshed`,
    "red": `R\xf8d`,
    "saturation": `Farvem\xe6tning`
};


export {$7097f64386f1761c$exports as default};
//# sourceMappingURL=da-DK.module.js.map
